/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'
import { getCheckoutItems } from './utils/_ga4-tracking-checkout'

export const addBeginCheckoutOnPageLoad = () => {
  const checkoutItems = getCheckoutItems()
  if (checkoutItems !== null) {
    GA4Tracking.pushEvent('begin_checkout', checkoutItems)
  }
}
